import * as Loading from "@repoflow/components/loading";
import { useQuery } from "@apollo/client";
import { useEffect } from "react";

export const QueryContent = ({
  children: Children,
  query,
  variables,
  context,
  // Passed straight through to Apollo, and undefined for every caller that does
  // not set it — which is all of them but one, so nothing else changes.
  //
  // It exists for reads whose RESULT IS A CONCURRENCY TOKEN. tablews' table
  // editor asks for a table's rows and the ETag they were read at, and its next
  // write is conditional on that ETag: answering from a cache filled minutes ago
  // by a different screen hands it a version that may already have been
  // replaced, and the person gets a save refused for a reason nothing on the
  // page can explain.
  fetchPolicy,
}) => {
  const { loading, error, data, refetch } = useQuery(query, { variables, fetchPolicy });

  if (loading)
    return (
      <div className="mt-4">
        <Loading.Content />
      </div>
    );
  if (error) return `Error! ${error.message}`;

  const account = data.viewer.account;

  if (!account) {
    return null;
  }

  return (
    <Children
      account={account}
      variables={variables}
      query={query}
      refetch={refetch}
      context={context}
    />
  );
};
